export default __webpack_public_path__ + "static/media/Bracers of the Huntmaster.63640492.jpg";